import PropTypes from 'prop-types';

const Section = ({header_image, tag_text, tag_color, title, text}) => {

    const colorVariants = {
        pink: 'bg-transformation-pink',
        blue: 'bg-transformation-blue',
    }

    return <div id='acercade' className="md:container mx-8 md:mx-auto my-8 lg:px-24">
        <div className="text-center pb-4">
            {header_image ?
                <img src={header_image} alt="headerimage" className="md:w-4/12 sm:w-12/12 mx-auto" /> : null
            }
        </div>
        <span className={`${colorVariants[tag_color]} inline-block text-black text-xs px-2 py-1 rounded-full uppercase tracking-wide mb-3`}>
            {tag_text}
        </span>
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
            <div className="text-3xl font-bold">{title}</div>
            <div>{text}</div>
        </div>
    </div>
}

Section.propTypes = {
    header_image: PropTypes.string,
    tag_text: PropTypes.string.isRequired,
    tag_color: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
};

export default Section;
